import { useQuery } from '@tanstack/react-query'
import { getEvents } from '../api'
import './Events.css'

export default function Events() {
  const { data: events = [], isLoading, error } = useQuery({
    queryKey: ['events'],
    queryFn: getEvents,
  })

  if (isLoading) return <div className="page-loading">טוען אירועים...</div>
  if (error) return <div className="page-error">שגיאה בטעינת אירועים</div>

  return (
    <div className="events-page">
      <h1>אירועים</h1>
      {events.length === 0 ? (
        <p className="page-empty">אין אירועים להצגה.</p>
      ) : (
        <div className="events-list">
          {events.map((e: { id: string; severity: string; category: string; title: string; message?: string; created_at: string }) => (
            <div key={e.id} className={`event-card event-${e.severity}`}>
              <div className="event-header">
                <span className="event-severity">{e.severity}</span>
                <span className="event-category">{e.category}</span>
                <span className="event-date">{new Date(e.created_at).toLocaleString('he-IL')}</span>
              </div>
              <h4>{e.title}</h4>
              {e.message && <p>{e.message}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
